import LocalizedStrings from "react-localization";

export const actionButtonsStrings = new LocalizedStrings({
  en: {
    markAsInvalid: "Mark as invalid",
    poolSize: "Pool Size",
    nextPool: "Next Pool",
    paperClipLabel: "Enter Paper Clip label",
    paperClip: "Paper clip",
    reject: "Reject",
    validate: "Validate",
    errors: {
      markAsInvalid: "An error occured",
    },
  },
  fr: {
    markAsInvalid: "Marquer comme invalide",
    poolSize: "Pool Size",
    nextPool: "Next Pool",
    paperClipLabel: "L'étiquette du Trombone",
    paperClip: "Trombone",
    reject: "Rejeter",
    validate: "Valider",
    errors: {
      markAsInvalid: "Une erreur s'est produite",
    },
  },
});
